import { Box, CircularProgress, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import UseGql from "@/services/graph-ql/useGql";
import { GetRangeByDuration, makeCustomParams } from "../helper";
import { LineChart } from "@/components/charts/Line-chart";
import { BarChart } from "@/components/charts/bar-chart";
import { Chart_Types, ReportEnums } from "../../global/constants";
// import WidgetGraph from "./widget-graph-comp";
import WidgetGraphWrapper from "./widget-graph/widget-graph-wrapper";
import WidgetGraphWrapperLeadGenerated from "./widget-graph/widget-graph-wrapper-lead-generated";
import { knowncolumns } from "@/components/grid-wrapper/dynamic-columns-generator";
import moment from "moment";
import { useDispatch, useSelector } from "react-redux";
import HorizontalCapsuleBarChart from "@/components/charts/horizontal-capsule-bar";
import {
  getDropdownOptions,
  setLeadContactedUsersToState,
} from "@/store/slices/general/dropdownOptionsSlice";
import { PieChart } from "@/components/charts/pie-chart";
import FunnelChart from "@/components/charts/funnel-chart";
import {
  getObjectKeyByValue,
  WidgetDurationEnums,
} from "@/services/dropdown-enums";

export const XlabelGenerator = (
  label = "",
  range = [],
  fields = [],
  filters
) => {
  if (label == "date_range") {
    let field = fields[0];
    let d1 = "";
    let d2 = "";
    if (filters?.[field?.name]) {
      d1 = filters[field.name].startDate;
      d2 = filters[field.name].endDate;
    } else if (filters?.id) {
      const key = getObjectKeyByValue(WidgetDurationEnums, filters?.id);
      const { first } = GetRangeByDuration(key.toLowerCase());

      d1 = first.gte;
      d2 = first.lte;
    }
    let start = moment(d1 || range[0]).format("MMM DD, YYYY");
    let end = moment(d2 || range[range.length - 1]).format("MMM DD, YYYY");

    return `${start} - ${end}`;
  } else {
    return label;
  }
};

const GraphView = ({
  query,
  secondQuery,
  secondDataKey = "",
  secondItemKey = "",
  dataKey = "",
  filters,
  type,
  graphStyles = {},
  columns,
  graphInfo,
  fields = [],
  showAxesLabels = true,
  widgetUnit = "",
  ...rest
}) => {
  const dispatch = useDispatch();
  const [data, setData] = useState([]);
  const [secondData, setSecondData] = useState(null);
  const [contactedTeamMembers, setContactedTeamMembers] = useState([]);
  const dropdownOptions = useSelector(getDropdownOptions());
  // const [filter, setFilter] = useState({ id: 1, title: "Today" });
  const { executeQuery, loading } = UseGql(
    query,
    { variables: {} },
    "report",
    {},
    true
  );
  const secondAPI = UseGql(secondQuery, { variables: {} }, "report", {}, true);

  useEffect(() => {
    if (rest.id == ReportEnums.Leads_contacted_by_team_member) fetchData(true);
  }, []);

  useEffect(() => {
    fetchData();
  }, [JSON.stringify(filters)]);

  const fetchData = (initial = false) => {
    let { params, outSideParams } = makeCustomParams(filters, fields);
    if (graphInfo?.staticFilters) {
      params.push(...graphInfo.staticFilters);
    }
    if (filters?.showNull == false) {
      params.push(
        ...[{ countryId: { neq: null } }, { stateProvinceId: { neq: null } }]
      );
    }
    let payload;
    if (graphInfo?.useFilterPayload) {
      const filter = {
        startDate: moment(outSideParams.startDate)
          .startOf("day")
          .format("YYYY-MM-DD HH:mm"),
        endDate: moment(outSideParams.endDate)
          .endOf("day")
          .format("YYYY-MM-DD HH:mm"),
      };
      params.forEach((p) => {
        const key = Object.keys(p)[0];
        const cond = p[key];
        if (cond?.eq != null) filter[key] = cond.eq;
        else if (cond?.in != null) filter[key] = cond.in;
      });
      payload = {
        filter,
        skip: 0,
        take: 100,
      };
    } else {
      payload = {
        where: { and: params },
        skip: 0,
        take: 100,
        ...outSideParams,
      };
    }
    if (
      [
        ReportEnums.Active_Workflows_Activity_Report,
        ReportEnums.Leads_by_location,
      ].includes(Number(rest.id))
    ) {
      payload["fetchAll"] = true;
    }

    executeQuery(payload).then((res) => {
      const { data } = res;
      if (data && data?.[dataKey]) {
        setData(data?.[dataKey]);

        if (initial) {
          let members = data?.[dataKey]?.items.map((d) => d.teamMemberId);
          let filtered = dropdownOptions.users.filter((f) =>
            members.includes(f.id)
          );

          dispatch(setLeadContactedUsersToState(filtered));
        }
      }
    });
  };

  const checkGraphInfo = (temp) => {
    return graphInfo?.graphDataMapper
      ? graphInfo.graphDataMapper(
          temp,
          graphInfo?.checkBoxOptionsKey
            ? knowncolumns[graphInfo?.checkBoxOptionsKey || "userId"]()
            : knowncolumns,
          filters
        )
      : temp;
  };

  const getGraphPropOptions = () => {
    if (graphInfo?.graphOptions) {
      return graphInfo.graphOptions();
    }
  };

  const MakeGraphByType = () => {
    let mappedData = checkGraphInfo(data?.items || data || []);
    let graphPropOptions = getGraphPropOptions();
    let filterKey = fields.find((f) => f.type == "date_range")?.name || "";

    switch (type) {
      case Chart_Types.horizontal_capsule_bar:
        return (
          <HorizontalCapsuleBarChart
            sx={{ height: "100%" }}
            {...mappedData}
            {...(filters?.[filterKey] || {})}
            {...graphPropOptions}
          />
        );
      case Chart_Types.bar_h_multiple:
        return (
          <BarChart
            values={[
              [100, 200, 300, 400, 500, 600],
              [100, 200, 300, 400, 500, 600],
              [100, 200, 300, 400, 500, 600],
            ]}
            isMultipleDataSets={true}
            alignment={"y"}
            sx={{ height: "100%" }}
            {...mappedData}
            {...(filters?.[filterKey] || {})}
            {...graphPropOptions}
          />
        );
      case Chart_Types.bar_v_single:
        return (
          <BarChart
            {...mappedData}
            color={graphInfo?.singleColor}
            sx={{ height: "100%" }}
            alignment={"x"}
            yLabel={
              showAxesLabels ? graphInfo?.yLabel : "Number of Appointments"
            }
            borderSkipped={false}
            truncateLabelX={8}
            {...(filters?.[filterKey] || {})}
          />
        );
      case Chart_Types.bar_h_single:
        return (
          <BarChart
            {...mappedData}
            alignment={"y"}
            sx={{ height: "100%" }}
            xLabel={
              showAxesLabels
                ? XlabelGenerator(
                    graphInfo?.xLabel,
                    mappedData?.labels,
                    fields,
                    filters
                  )
                : ""
            }
            yLabel={showAxesLabels ? graphInfo?.yLabel(filters) : ""}
            {...(filters?.[filterKey] || {})}
            {...graphPropOptions}
          />
        );
      case Chart_Types.line_multiple:
        return (
          <LineChart
            // color="single"

            isMultipleDataSets={true}
            sx={{ height: "100%" }}
            // sx={{ height: "calc(100vh - 180px)" }}
            {...mappedData}
            xLabel={
              showAxesLabels
                ? XlabelGenerator(
                    graphInfo?.xLabel,
                    mappedData?.labels,
                    fields,
                    filters
                  )
                : ""
            }
            yLabel={showAxesLabels ? graphInfo?.yLabel() : ""}
            unit={graphInfo?.unit}
            customTooltip={graphInfo?.customTooltip}
            {...(filters?.[filterKey] || {})}
            {...graphPropOptions}
          />
        );
      case Chart_Types.line_single:
        return (
          <LineChart
            color={graphInfo?.color}
            sx={{ height: "100%" }}
            {...mappedData}
            xLabel={
              showAxesLabels
                ? XlabelGenerator(
                    graphInfo?.xLabel,
                    mappedData?.labels,
                    fields,
                    filters
                  )
                : ""
            }
            yLabel={showAxesLabels ? graphInfo?.yLabel() : ""}
            unit={graphInfo?.unit}
            {...(filters?.[filterKey] || {})}
            {...graphPropOptions}
          />
        );
      case Chart_Types.pie:
        return (
          <PieChart
            // alignment={"y"}
            sx={{ height: "100%" }}
            {...mappedData}
            {...(filters?.[filterKey] || {})}
            // values={[
            //   [100, 200, 300, 400, 500, 600],
            //   [100, 200, 300, 400, 500, 600],
            // ]}
          />
        );
      case Chart_Types.funnel:
        return (
          <FunnelChart
            sx={{ height: "100%" }}
            {...mappedData}
            xLabel={showAxesLabels ? graphInfo?.xLabel : ""}
            yLabel={showAxesLabels ? graphInfo?.yLabel : ""}
            {...(filters?.[filterKey] || {})}
            {...graphPropOptions}
          />
        );
      case Chart_Types.widget:
        return rest?.gridType == "duration" ? (
          <WidgetGraphWrapperLeadGenerated
            value={data?.totalCount || 0}
            query={query}
            dataKey={dataKey}
            loading={loading}
            columns={columns}
          />
        ) : (
          <WidgetGraphWrapper
            value={secondData?.[secondItemKey] || data?.totalCount || 0}
            unit={widgetUnit}
            data={data}
            query={query}
            dataKey={dataKey}
            loading={loading || secondAPI?.loading}
            columns={columns}
            secondDataKey={graphInfo?.secondDataKey}
          />
        );
    }
  };

  return (
    <Box
      className="custom-scroll"
      sx={{ overflowY: "auto", mt: 1, ...graphStyles }}
    >
      {loading ? (
        <div style={{ textAlign: "center", height: "100%", marginTop: "1rem" }}>
          <CircularProgress
            // sx={{ position: "absolute", bottom: "50%" }}
            size={"60px"}
          />
        </div>
      ) : (data?.items?.length == 0 ||
          data.length == 0 ||
          data?.items?.[graphInfo?.secondDataKey]?.length == 0) &&
        !loading ? (
        // <EmptyGraphCard />
        <Box
          className="d-flex align-items-center justify-content-center "
          sx={{ height: "-webkit-fill-available" }}
        >
          <Typography variant="h5" color="custom.grey_text">
            No records available
          </Typography>
        </Box>
      ) : (
        MakeGraphByType()
      )}
    </Box>
  );
};

export default GraphView;
